export default __webpack_public_path__ + "static/media/kz.a7a4a36b.svg";